import React, { Component } from "react";
interface IProps {
    title: string;
    open?: boolean;
}
interface IState {
    open: boolean;
}

export class Accordion extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            open: props.open ? props.open : false,
        };
    }
    onClickAccordion(e): void {
        if (e.target.checked && !this.state.open) {
            this.setState({
                open: true,
            });
        } else if (e.target.checked && this.state.open) {
            this.setState({
                open: false,
            });
        }
    }
    render() {
        return (
            <>
                <div className="accord w-full overflow-hidden mb-3">
                    <input
                        className="absolute opacity-0"
                        id="accord-single-one"
                        type="radio"
                        checked={this.state.open}
                        onClick={(e) => this.onClickAccordion(e)}
                    />
                    <label
                        className="block p-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl"
                        htmlFor="accord-single-one"
                    >
                        {this.props.title}
                    </label>
                    <div className="accord-content accord-content-bg overflow-hidden leading-normal">
                        <div className=" accord-content-inner">
                            <div className="flex flex-wrap w-full">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Accordion;
